const mmoBaseUrl = '/mediaMixOptimizers';

function getOptimizers() {
    const uri = `${mmoBaseUrl}`;
    return axios.get(uri).then(R.prop('data'));
}

function createOptimizer() {
    const uri = `${mmoBaseUrl}`;
    return axios.post(uri).then(R.prop('data'));
}

function getOptimizer({ optimizerId }) {
    const uri = `${mmoBaseUrl}/${optimizerId}`;
    return axios.get(uri).then(R.prop('data'));
}

function updateOptimizer(optimizer) {
    const { id } = optimizer;
    const uri = `${mmoBaseUrl}/${id}`;
    return axios.put(uri, optimizer).then(R.prop('data'));
}
function deleteOptimizer({ optimizerId }) {
    const uri = `${mmoBaseUrl}/${optimizerId}`;
    return axios.delete(uri).then(R.prop('data'));
}

// campaigns under an optimizer
function getAddedCampaigns({ optimizerId }) {
    const uri = `${mmoBaseUrl}/${optimizerId}/campaign`;
    return axios.get(uri).then(R.prop('data'));
}

// campaigns to add
function getAvailableCampaigns({ optimizerId }) {
    const uri = `${mmoBaseUrl}/${optimizerId}/availableCampaigns`;
    return axios.get(uri).then(R.prop('data'));
}

function deleteCampaign({ optimizerId, campaignId }) {
    const uri = `${mmoBaseUrl}/${optimizerId}/campaign/${campaignId}`;
    return axios.get(uri).then(R.prop('data'));
}

function startOptimizer({ id }) {
    const uri = `${mmoBaseUrl}/${id}/start`;
    return axios.put(uri).then(R.prop('data'));
}

function stopOptimizer({ id }) {
    const uri = `${mmoBaseUrl}/${id}/stop`;
    return axios.put(uri).then(R.prop('data'));
}

export default {
    getOptimizers,
    getOptimizer,
    createOptimizer,
    updateOptimizer,
    deleteOptimizer,
    getAddedCampaigns,
    getAvailableCampaigns,
    deleteCampaign,
    stopOptimizer,
    startOptimizer,
};
